import { Dealer } from "../../dealer/shared/dealer.model";
import { Country } from "../../postal/country.model";
import { AddressableUser } from "../../user/addressable-user.model";

export class Customer extends AddressableUser {

    public static override stringifyExclude: string[] = [
        "_dealer_id",
        "_dealer",
        "_user_roles"
    ];

    private _dealer_id: number = -1;
    private _business_name: string = "";
    private _dealer: Dealer | null | undefined;

    public constructor() {
        super();
    }

    public get dealer_id(): number {
        return this._dealer_id;
    }

    public set dealer_id(value: number) {
        this._dealer_id = value;
    }

    public get business_name(): string {
        return this._business_name;
    }

    public set business_name(value: string) {
        this._business_name = value;
    }

    public get dealer(): Dealer | null | undefined {
        return this._dealer;
    }

    public set dealer(value: Dealer) {
        this._dealer = value;
    }

    // This function, when present, is automatically
    // called by the JSON.stringify function.
    public override toJSON() {
        return super.toJSON(Customer.stringifyExclude);
    }

    public static toCustomers(obj: string | Object[]): Customer[] {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let customers: Customer[] = [];

        for (const o2 of (<Object[]>obj2)) {
            customers.push(Customer.toCustomer(o2));
        }

        return customers;
    }

    public static toCustomer(obj: string | Object): Customer {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of Customer.
        let customer: Customer = Object.assign(new Customer(), obj2);

        if (customer.country != null) {
            customer.country = Country.toCountry(customer.country);
        }

        if (customer.dealer != null) {
            customer.dealer = Dealer.toDealer(customer.dealer);
        }

        return customer;
    }
}
